import { defineStore } from "pinia";
import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import router from "@/router/starter";

export const useAuthStore = defineStore({
  id: "auth",
  state: () => ({
    errors: null,
    moduleName: "Auth",
    user: null,
    isAuthenticated: false,
    dealerId: null,
  }),
  actions: {
    setAuth(authUser, remember) {
      //console.log("setAuth", authUser);
      this.isAuthenticated = true;
      this.user = authUser;
      this.dealerId = authUser.dealerId;
      JwtService.saveToken(
        this.user.token.token,
        this.user.token.refreshToken,
        remember,
      );
    },
    setError(error) {
      this.errors = error;
    },
    purgeAuth() {
      this.isAuthenticated = false;
      this.user = null;
      JwtService.destroyToken();
    },
    logout() {
      this.purgeAuth();
      router.push({ name: "sign-in" });
    },
    login(credentials, remember = true) {
      return ApiService.post(`${this.moduleName}/Login`, credentials)
        .then(({ data }) => {
          this.setError(null);
          this.setAuth(data, remember);
        })
        .catch(({ response }) => {
          // ObjectResult ({ value: { detail } }) veya ProblemDetails ({ detail }) biçimi
          this.setError(response?.data?.value?.detail ?? response?.data?.detail ?? "Giriş yapılamadı.");
          throw response;
        });
    },
    async verifyAuth() {
      var result = true;
      if (JwtService.getToken()) {
        ApiService.setHeader();

        const verify = () =>
          ApiService.post(`${this.moduleName}/VerifyToken`, {
            token: JwtService.getToken(),
            refreshToken: JwtService.getRefreshToken(),
          });

        try {
          let response;
          try {
            response = await verify();
          } catch (error) {
            // Erişim token'ının süresi dolduysa (60 dk) önce sessizce yenile, sonra tekrar doğrula (#37)
            if (error.response?.status !== 401 || !(await ApiService.refreshSession())) throw error;
            response = await verify();
          }

          this.setError(null); // Eğer hata yoksa, hatayı temizliyoruz
          this.setAuth(response.data); // Kimlik doğrulama başarılıysa yetkilendirme verilerini set ediyoruz
        } catch (error) {
          //console.log("verifyAuth error", error);
          result = false; // Hata durumunda result'u false yapıyoruz
          this.setError(error.response?.data?.value?.detail); // Hata mesajını store'da set ediyoruz
        }
      } else {
        result = false;
        this.purgeAuth();
      }
      return result;
    },
  },
});
